export default function stopPointsList(state = [], action) {
  switch (action.type) {
    default:
      return state
  }
}